import React from 'react';

import TeamDisplayModule from '../teamDisplayModule';

import Input from '@nhl/nhl-react-ui/lib/Forms/Input';

import { listType } from '../teamsList';
import { teamsByLeagueListPropTypes } from './propTypes';

const TeamsByLeagueList = ({ teams, season, ...props }) => {

    const isFilterList = (props.listType === listType.FILTER_LIST);

    const areAllChecked = (
        (selectedTeams, teams) => teams.every(team => selectedTeams.find(selectedTeam => selectedTeam.id === team.id))
    );

    const views = teams.map(team => {
        return (
            <TeamDisplayModule
                key={ team.id }
                team={ team }
                season={ season }
                { ...props }
            />
        )
    });

    return (
        <div className="league-container">
            {
                isFilterList
                    ?   <div className="league-header">
                            <Input
                                type="checkbox"
                                id="all"
                                key="all"
                                label="All"
                                onChange={ props.teamDisplayProps.changeAllSelection }
                                checked={ areAllChecked(props.teamDisplayProps.selectedTeams, teams) }
                            />
                        </div>
                    :   null
            }
            <div className="league-teams">
                { views }
            </div>
        </div>
    )
};

TeamsByLeagueList.propTypes = teamsByLeagueListPropTypes;

export default TeamsByLeagueList
